export const TypesObterSkill = {
    OBTERSKILL: "OBTERSKILL",
    REMOVERSKILL: "REMOVERSKILL",
    SKILLSELECIONADA: "SKILLSELECIONADA"
  }
  
  const INITIAL = {
    AcessoConfere: false,
    AcessoImagemGeral: false,
    SkillSelecionada: ""
  }
  
  export default function obterSkillReducer(state = INITIAL, action) {
    switch (action.type) {
      case TypesObterSkill.OBTERSKILL:
        return {
          ...state,
          AcessoConfere: action.payload.AcessoConfere,
          AcessoImagemGeral: action.payload.AcessoImagemGeral,
          SkillSelecionada: ""
        }
      case TypesObterSkill.REMOVERSKILL:
        return {
          ...state,
          AcessoConfere: false,
          AcessoImagemGeral: false,
          SkillSelecionada: ""
        }
      case TypesObterSkill.SKILLSELECIONADA:
        return {
          ...state,
          SkillSelecionada: action.payload.SkillSelecionada
        }
      default:
        return state;
    }
  }
  
  export const obterSkillActions = {
    addSkill,
    removerSkill,
    selectedSkill
  }
  
  function addSkill(confere, imagemGeral) {
    return {
      type: TypesObterSkill.OBTERSKILL,
      payload: { AcessoConfere: confere, AcessoImagemGeral: imagemGeral }
    }
  }
  
  function removerSkill() {
    return {
      type: TypesObterSkill.REMOVERSKILL
    }
  }
  
  function selectedSkill(skill) {
    return {
      type: TypesObterSkill.SKILLSELECIONADA,
      payload: { SkillSelecionada: skill }
    }
  }